import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppStateHandler from "src/StateHandlers/AppStateHandler";

function NavBar() {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const handleLanguage = (lang: "en" | "fr" | "ar") => {
    AppStateHandler.setLocale(lang)
  }
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <div style={{ width: 73 }}>
            <img
              src="/assets/images/logo.png"
              className="img-fluid"
              alt="Houmti Logo"
            />
          </div>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto fz14 align-items-lg-center">
            <li className="nav-item">
              <Link className="nav-link" to="/welcome">
                {t("Home")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                {t("About")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/privacy-policy">
                {t("Privacy Policy")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/terms-and-condition">
                {t("Terms & Conditions")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/faq">
                {t("FAQ")}
              </Link>
            </li>
            <li className={`nav-item ${i18n.dir() === "rtl" ? "mr-3":"ml-3"}`}>
              <Link to="/login">
                <button className="btn custom_btn">{t("Login")}</button>
              </Link>
            </li>
            <li>
            <div className={`slider_down_arrow position-relative notification_part ${i18n.dir() === "rtl" ? "mr-3":"ml-3"}`}>
                <span className="lang_icon">
                  <img
                    src={language === 'fr' ?
                     '/assets/images/franch@2x.png' 
                     : language === 'en' 
                     ? '/assets/images/usa@2x.png' 
                     : '/assets/images/arabic@2x.png'}
                    className={i18n.dir() === "rtl" ? "ml-4":"mr-4"}
                    height="25"
                    alt=""
                  />
                  <i
                    className="fa fa-sort-desc fz18 pb-2"
                    title="Account"
                    aria-hidden="true"
                  > </i>
                </span>
                <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL Almaraibold':'user_actions_posLTR poppinsbold'}`}>
                  <ul className="list-unstyled text-center mb-0  pr-0">
                    <li className="cursor-pointer m-3" onClick={() => handleLanguage('en')}>
                      <img
                        src="/assets/images/usa@2x.png"
                        className={i18n.dir() === "rtl" ? "ml-4":"mr-4"}
                        height="25"
                        alt=""
                      />
                      {t("English")}
                    </li>
                    <li className="cursor-pointer m-3" onClick={() => handleLanguage('fr')}>
                      <img
                        src="/assets/images/franch@2x.png"
                        className={i18n.dir() === "rtl" ? "ml-4":"mr-4"}
                        height="25"
                        alt=""
                      />
                      {t("French")}
                    </li>
                    <li className="cursor-pointer m-3" onClick={() => handleLanguage('ar')}>
                      <img
                        src="/assets/images/arabic@2x.png"
                        className={i18n.dir() === "rtl" ? "ml-4":"mr-4"}
                        height="25"
                        alt=""
                      />
                      {t("Arabic")}
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
